module.exports = __webpack_public_path__ + "img/index_02_pic@2x.e870e1cd.png";